import React from 'react';

import { Switch, Route, useRouteMatch } from 'react-router-dom';

import NotFound from '../../NotFoundPage';
import RaisingsParticipants from 'src/components/Models/Raisings/Raisings/Participants';

function FundPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={RaisingsParticipants} />
      {/* <Route path={`${path}/:fundId`} component={FundRaisings} /> */}
      <Route path="" component={NotFound} />
    </Switch>
  );
}

FundPage.propTypes = {};

export default FundPage;
